/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Discounts_Basic_SettingsInputs */

const en_admin_discounts_basic_settings = /** @type {(inputs: Admin_Discounts_Basic_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basic Settings`)
};

/** @type {(inputs: Admin_Discounts_Basic_SettingsInputs) => LocalizedString} */
const de_admin_discounts_basic_settings = en_admin_discounts_basic_settings;

/** @type {(inputs: Admin_Discounts_Basic_SettingsInputs) => LocalizedString} */
const es_admin_discounts_basic_settings = en_admin_discounts_basic_settings;

/** @type {(inputs: Admin_Discounts_Basic_SettingsInputs) => LocalizedString} */
const fr_admin_discounts_basic_settings = en_admin_discounts_basic_settings;

/** @type {(inputs: Admin_Discounts_Basic_SettingsInputs) => LocalizedString} */
const it_admin_discounts_basic_settings = en_admin_discounts_basic_settings;

/** @type {(inputs: Admin_Discounts_Basic_SettingsInputs) => LocalizedString} */
const pt_br2_admin_discounts_basic_settings = en_admin_discounts_basic_settings;

/** @type {(inputs: Admin_Discounts_Basic_SettingsInputs) => LocalizedString} */
const pl_admin_discounts_basic_settings = en_admin_discounts_basic_settings;

/** @type {(inputs: Admin_Discounts_Basic_SettingsInputs) => LocalizedString} */
const hu_admin_discounts_basic_settings = en_admin_discounts_basic_settings;

/** @type {(inputs: Admin_Discounts_Basic_SettingsInputs) => LocalizedString} */
const ro_admin_discounts_basic_settings = en_admin_discounts_basic_settings;

/**
* | output |
* | --- |
* | "Basic Settings" |
*
* @param {Admin_Discounts_Basic_SettingsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discounts_basic_settings = /** @type {((inputs?: Admin_Discounts_Basic_SettingsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discounts_Basic_SettingsInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discounts_basic_settings(inputs)
	if (locale === "de") return de_admin_discounts_basic_settings(inputs)
	if (locale === "es") return es_admin_discounts_basic_settings(inputs)
	if (locale === "fr") return fr_admin_discounts_basic_settings(inputs)
	if (locale === "it") return it_admin_discounts_basic_settings(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discounts_basic_settings(inputs)
	if (locale === "pl") return pl_admin_discounts_basic_settings(inputs)
	if (locale === "hu") return hu_admin_discounts_basic_settings(inputs)
	return ro_admin_discounts_basic_settings(inputs)
});
export { admin_discounts_basic_settings as "admin.discounts.basic_settings" }